let getCountries, setCountries, getChartMode, setChartMode;

const localStorage = window.localStorage;

export function initializeState(_getCountries, _setCountries, _getChartMode, _setChartMode) {

  // Callbacks
  getCountries = _getCountries;
  setCountries = _setCountries;
  getChartMode = _getChartMode;
  setChartMode = _setChartMode;


  document.querySelectorAll(".link.action").forEach(link => {
    link.addEventListener("click", async () => {
      constructUrlForSharing();
      link.classList.toggle("completed", true);
      setTimeout(() => {
        link.classList.toggle("completed", false);
      }, 5000);
    });
    link.addEventListener("touchstart", async () => {
      constructUrlForSharing();
      link.classList.toggle("completed", true);
      setTimeout(() => {
        link.classList.toggle("completed", false);
      }, 5000);
    }, {passive:true});

  });


  let countriesLoaded = loadCountriesFromQueryString();
  if (!countriesLoaded) {
    countriesLoaded = loadCountriesFromLocalStorage();
  }

  let chartModeLoaded = loadChartModeFromQueryString();
  if (!chartModeLoaded) {
    chartModeLoaded = loadChartModeFromLocalStorage();
  }

}

// Keys to use for the URL and local storage
const KEYS = {
  'COUNTRIES' : 'countries_v',
  'CHART_MODE' : 'chartmode'
}



export function loadCountriesFromLocalStorage() {
  let c = localStorage.getItem(KEYS.COUNTRIES);
  if (c) {
    setCountries(JSON.parse(c));
    return true;
  }
  return false;
}
export function loadChartModeFromLocalStorage() {
  let c = localStorage.getItem(KEYS.CHART_MODE);
  if (c) {
    setChartMode(JSON.parse(c));
    return true;
  }
  return false;
}



export function setLocalStorage() {

  // console.log('setting local storage');

  localStorage.setItem(KEYS.COUNTRIES, JSON.stringify(getCountries()));
  localStorage.setItem(KEYS.CHART_MODE, JSON.stringify(getChartMode()));
}

export function clearLocalStorage() {

  localStorage.removeItem(KEYS.COUNTRIES);
  localStorage.removeItem(KEYS.CHART_MODE);
  //console.log('localStorageCleared');

}


export function getQueryVariable(variable) {
  let query = window.location.search.substring(1);
  let vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) === variable) {

      let uri = decodeURIComponent(pair[1]);

      // This is some absolute trash-fire nonsense, but new URL(), used to construct these,
      // encodes spaces ' ' as '+', which, while loosely supported in browsers,
      // doesn't follow specs (see comments in https://stackoverflow.com/questions/2678551/when-should-space-be-encoded-to-plus-or-20)
      // Likewise, decodeURIComponent and decodeURI won't decode '+' back to a space.
      // So, we bolt on this silly replace to get them to be spaces again.
      uri = uri.replace(/\+/gi, ' ');

      return uri;
    }
  }
  //console.log('Query variable %s not found', variable);
}

export function loadCountriesFromQueryString() {
  let queryCountries = getQueryVariable(KEYS.COUNTRIES);
  if (queryCountries) {
    setCountries(queryCountries.split(','));
    return true;
  } else if (queryCountries === '') {
    setCountries([]);
    return true;
  }
  return false;
}
export function loadChartModeFromQueryString() {
  let queryMode = getQueryVariable(KEYS.CHART_MODE);
  if (queryMode) {
    setChartMode(queryMode);
    return true;
  }
  return false;
}


export async function constructUrlForSharing() {
  const url = new URL(window.location);
  url.searchParams.set(KEYS.COUNTRIES, getCountries().join(','));
  url.searchParams.set(KEYS.CHART_MODE, getChartMode());

  await navigator.clipboard.writeText(url);
}
